import {Component, ChangeDetectionStrategy, ChangeDetectorRef} from "@angular/core";

@Component({
  selector: "core-changedetectorref",
  template: `
  <usecase-container title="ChangeDetectorRef" src="core/changedetectorref">
    <usecase-content>
      <p>{{count}}</p>
    </usecase-content>
  </usecase-container>
    `,
  changeDetection: ChangeDetectionStrategy.CheckOnce
})
export class ChangeDetectorRefComponent {
  private count = 0;
  private _interval: any;

  constructor(private cd: ChangeDetectorRef) {
    this._interval = setInterval(() => {
      this.count++;
      this.cd.markForCheck();
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this._interval);
  }
}



/** WEBPACK FOOTER **
 ** ./script/core/changedetectorref/component.ts
 **/